<div style="width: 100%;" #chart></div>
